import posthog from 'posthog-js';

// PostHog for paltalabs.io. Off unless REACT_APP_POSTHOG_KEY is set at build time, so merging this
// changes nothing until the key is loaded in Vercel (paltalabs/internal-ops#328).
//
// Events go through the first-party proxy in vercel.json (/ingest), so ad blockers do not drop them.
// The region (US or EU, internal-ops#140) is decided there and in REACT_APP_POSTHOG_UI_HOST.
const KEY = process.env.REACT_APP_POSTHOG_KEY;
const API_HOST = process.env.REACT_APP_POSTHOG_HOST || '/ingest';
const UI_HOST = process.env.REACT_APP_POSTHOG_UI_HOST || 'https://us.posthog.com';

// Only the production site is tracked. Local dev and Vercel previews (*.vercel.app) never send an
// event, so they cannot pollute the funnel. A new production domain must be added here.
const PRODUCTION_HOSTS = ['paltalabs.io', 'www.paltalabs.io'];

export function shouldTrack(hostname, key = KEY) {
  return Boolean(key) && PRODUCTION_HOSTS.includes(hostname);
}

export function initAnalytics() {
  if (typeof window === 'undefined' || !shouldTrack(window.location.hostname)) return;

  posthog.init(KEY, {
    api_host: API_HOST,
    ui_host: UI_HOST,
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    // Known crawlers and headless browsers are dropped by posthog-js's user agent filter, which is on
    // by default; it is stated here so nobody turns it off by accident.
    opt_out_useragent_filter: false,
  });
  posthog.register({ site: 'paltalabs.io' });
}
